"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._validator = void 0;
const is_empty_1 = require("utils/is-empty");
const initialErrorStatus = {
    hopper: { status: false, message: 'Required' },
    is_active: { status: false, message: 'Required' },
    hopper_type: { status: false, message: 'Required' },
};
const _validator = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    let validate = {
        isError: false,
        data: initialErrorStatus
    };
    try {
        if ((0, is_empty_1.isEmpty)(arg.hopper_type)) {
            validate = {
                isError: true,
                data: Object.assign(Object.assign({}, validate.data), { hopper_type: { status: true, message: 'Required' } })
            };
        }
        if ((0, is_empty_1.isEmpty)(arg.hopper)) {
            validate = {
                isError: true,
                data: Object.assign(Object.assign({}, validate.data), { hopper: { status: true, message: 'Required' } })
            };
        }
        if ((0, is_empty_1.isEmpty)(arg.is_active)) {
            validate = {
                isError: true,
                data: Object.assign(Object.assign({}, validate.data), { is_active: { status: true, message: 'Required' } })
            };
        }
        return validate;
    }
    catch (error) {
        return {
            isError: false,
            data: initialErrorStatus
        };
    }
});
exports._validator = _validator;
